module.exports = __webpack_public_path__ + "img/yasuo.8c4a946b.jpg";